import { buildInfiniteScrollingArticlesUrl, getVideoSearchUrl } from './build-urls';

export const getVideoCarouselAssetsArray = async (tabData, baseUrl, hlPrevTags) => {
  let videoSearchUrl = '';
  videoSearchUrl = getVideoSearchUrl(tabData, baseUrl, hlPrevTags);
  if (videoSearchUrl) {
    const response = await fetch(videoSearchUrl);
    const parsedJson = await response.json();
    return parsedJson.assets || [];
  }
  return [];
};

const getInfiniteJson = async (url) => {
  const articlesUrl = buildInfiniteScrollingArticlesUrl(url);
  const response = await fetch(articlesUrl);
  const json = await response.json();
  return json;
};

export const getInfiniteData = async (dataURL) => {
  const articlesJson = await getInfiniteJson(dataURL);
  return articlesJson;
};
